<h2>Review your listings</h2>

<p class="sub-p">
  Please select which listings you would like your property manager to manage within
  {{ 'CORE.PRODUCT_NAME' | transloco }}. Any listings not selected will be muted. Selecting a previously muted listing
  will un-mute it.
</p>

<mat-spinner [diameter]="24" *ngIf="loading"></mat-spinner>

<ng-container *ngIf="listings?.length > 0">
  <div *ngFor="let listing of listings" class="invited-listing">
    <mat-checkbox [(ngModel)]="listing.allowAccess" [disabled]="!listing.mutable">
      <div class="flex gap-3 items-center">
        <img *ngIf="listing.picture" [src]="listing.picture" [alt]="listing.name" class="listing-img ml-2" />
        <div class="listing-name flex-1 justify-items-center ellipsis">
          <div [class.strikethrough]="listing.muted">{{ listing.name }}</div>
          <div *ngIf="listing.muted" class="text-xs text-night-lighter">Muted</div>
        </div>
      </div>
    </mat-checkbox>
  </div>

  <div class="flex items-center justify-end">
    <sbnb-button [loading]="submitting" label="Continue" (clicked)="syncPropertiesSelection()"></sbnb-button>
  </div>
</ng-container>
